import { Route, Switch, BrowserRouter } from "react-router-dom";
import NotFoundPage from "../pages/NotFoundPage";
import ProtectedRoute from "./routeGate";
import routers from "./router";
import MainLayout from "src/components/LayoutC/MainLayout";
import App from "src/App";
import LocalizationProvider from "src/shared/provider/localization.provider";

export default function Routes() {
  const panelRoute = routers
    .filter((item) => item.protect == true)
    .map((route) => (
      <ProtectedRoute
        protect={route.protect}
        exact={route.exact}
        path={route.path}
        permission={route?.permission}
        component={route.Component}
      />
    ));
  const publicRoute = routers
    .filter((item) => item.protect == false)
    .map((route) => (
      <ProtectedRoute
        protect={route.protect}
        exact={route.exact}
        path={route.path}
        permission={route?.permission}
        component={route.Component}
      />
    ));

  return (
    <div>
      <BrowserRouter>
        <LocalizationProvider>
          <App>
            <Switch>
              <Route path={["/panel"]}>
                <MainLayout>
                  <Switch>{panelRoute}</Switch>
                </MainLayout>
              </Route>
              <Route path={["/", "/public"]}>
                <MainLayout>
                  <Switch>{publicRoute}</Switch>
                </MainLayout>
              </Route>
              <Route component={NotFoundPage} />
            </Switch>
          </App>
        </LocalizationProvider>
      </BrowserRouter>
    </div>
  );
}
